import {PlayerReducer, ReducerFromState} from "../../../@types/reducers";
import {AlertPlayerObject} from "../../../@types/response";

export const getMonitors = (state: ReducerFromState<PlayerReducer>): Array<AlertPlayerObject> => state.player.monitors;
